import Vue from 'vue';

// Automatic global registration of components

// 1. The relative path of the folder to be automatically required (only)
// 2. Should webpack look in subfolders?
// 3. The regular expression used to match filenames
const requireComponents = require.context(
  '.', // 1.
  false, // 2,
  /Base[A-Z]\w+\.(vue|js)$/ // 3.
).keys().map(fileName => fileName.split('/').pop().replace(/\.\w+$/, ''));

// 1. Get component config from path
// 2. Remove './' from the start
// 3. Remove extension from the end
// 4. Register component globally
// 5. Look for the component options on `.default`, which will
// exist if the component was exported with `export default`,
// otherwise fall back to module's root.
// Register each component as a lazy-loaded async component
requireComponents.forEach(componentName => {
  Vue.component(componentName, () => import(
    /* webpackChunkName: "base-[request]" */
    `./${componentName}.vue`
  ));
});